import { options_premiumSubOption_Security } from './premiumDashboardSecuritySubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import { AdvancedSecurityOption } from 'owa-security-advanced-option';
import { AccountSecurityOption } from 'owa-security-account-option';

let premiumDashboardSecuritySubCategory: OptionSubCategory = {
    key: 'security',
    titleStringKey: options_premiumSubOption_Security,
    options: [AccountSecurityOption, AdvancedSecurityOption],
};

export default premiumDashboardSecuritySubCategory;
